import { ComponentPublicInstance, onMounted, onUnmounted, ref, Ref } from 'vue';
import { debounce } from '../utils';

/**
 * @param $element Ссылка на элемент
 * @param updateInterval Интерфал обновления
 * @param defaultWidth Дефолтная ширина до вычисления размера
 * @returns
 */
export const useResizeObserve = (
  $element: Ref<ComponentPublicInstance>,
  updateInterval: number = 100,
  defaultWidth: number = 0,
) => {
  /**Ширина элемента */
  const width = ref<number>(defaultWidth);

  /**Метод обновления ширины */
  const updateWidth = (value: number) => {
    width.value = value;
  };
  /**Метод обновления ширины (debounce) */
  const debounceUpdateWidth = debounce(updateWidth, updateInterval);

  /**При изменении размера элемента */
  const onResize = (entries: ResizeObserverEntry[]) => {
    if (entries.length && entries[0].borderBoxSize.length) {
      debounceUpdateWidth(entries[0].borderBoxSize[0].inlineSize);
    }
  };

  /**Наблюдатель */
  const observer = new ResizeObserver(onResize);

  onMounted(() => {
    if ($element.value) observer.observe($element.value?.$el);
  });
  onUnmounted(() => {
    observer.disconnect();
  });

  return {
    /**Ширина элемента */
    width,
  };
};
